import React, { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Grid, Paper, Chip } from '@mui/material';
import styles from './UserDetailsCard.module.scss';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

const UserDetailsCard = ({
	userId,
	usersList,
	projects,
	rolesOfAllProjects,
	projectSelectedCode,
}) => {
	const [clickedUser, setClickedUser] = useState();
	const [userCompany, setUserCompany] = useState();
	const [userRole, setUserRole] = useState();
	const [userProjects, setUserProjects] = useState([]);

	useEffect(() => {
		let userListKeys = Object.keys(usersList);

		let userFound;

		userListKeys.forEach((key) => {
			var user = usersList[key];

			if (user['id'] === userId) {
				userFound = user;
			}
		});

		if (userFound) {
			setClickedUser(userFound);
		} else {
			setClickedUser();
		}
	}, [userId, usersList]);

	useEffect(() => {
		if (clickedUser?.projectRoles[projectSelectedCode] !== undefined) {
			let filteredProject = projects?.filter(
				(project) => project.id === projectSelectedCode
			);
			if (filteredProject?.length > 0) {
				setUserCompany(filteredProject[0]);
			} else {
				setUserCompany();
			}
		} else {
			setUserCompany();
		}
	}, [clickedUser, projectSelectedCode, projects]);

	useEffect(() => {
		if (clickedUser?.projectRoles[projectSelectedCode] !== undefined) {
			let filteredRoles = rolesOfAllProjects?.filter(
				(role) =>
					role.roleId ===
						clickedUser?.projectRoles[projectSelectedCode] &&
					role.projectCode === projectSelectedCode
			);
			if (filteredRoles?.length > 0) {
				setUserRole(filteredRoles[0]);
			} else {
				setUserRole();
			}
		} else {
			setUserRole();
		}
	}, [clickedUser, rolesOfAllProjects, projectSelectedCode]);

	useEffect(() => {
		if (clickedUser?.projectRoles && rolesOfAllProjects) {
			let projectRoleArr = [];
			for (let projectId in clickedUser.projectRoles) {
				if (clickedUser.projectRoles[projectId]) {
					let filtered = rolesOfAllProjects.filter(
						(role) =>
							role.projectCode === projectId &&
							role.roleId === clickedUser.projectRoles[projectId]
					);
					if (filtered.length > 0) {
						let companyName = '';
						if (projects) {
							let filteredProjects = projects.filter(
								(project) => project.id === projectId
							);
							if (filteredProjects.length > 0) {
								companyName = filteredProjects[0].companyName;
							}
						}
						projectRoleArr.push({
							...filtered[0],
							companyName: companyName,
						});
					}
				} else {
					if (projects) {
						let filteredProjects = projects.filter(
							(project) => project.id === projectId
						);
						if (filteredProjects.length > 0) {
							let companyName = filteredProjects[0].companyName;
							projectRoleArr.push({
								companyName: companyName,
							});
						}
					}
				}
			}
			setUserProjects(projectRoleArr);
		} else {
			setUserProjects([]);
		}
	}, [clickedUser, rolesOfAllProjects, projects]);

	return (
		<div>
			<div className={styles.userDetails}>
				<div className={styles.userDetails_header}>
					{clickedUser ? (
						<>
							<div className={styles.name}>
								{clickedUser?.fullName}
								{userRole?.roleName &&
									` - ${userRole?.roleName}`}
							</div>
							<div className={styles.subDetail}>
								{`${clickedUser?.email} | ${clickedUser?.phoneNumber}`}
							</div>
						</>
					) : (
						<div className={styles.user_info_title}>
							User Information
						</div>
					)}
				</div>
				<div className={styles.content}>
					{clickedUser ? (
						<>
							<Grid
								container
								xs={12}
								style={{ marginBottom: '20px' }}
							>
								<Grid item className={styles.detailItem} xs={6}>
									<div className={styles.detail_item_title}>
										Company
									</div>
									<div className={styles.detail_item_content}>
										{userCompany?.companyName}
									</div>
								</Grid>
								<Grid item className={styles.detailItem} xs={6}>
									<div className={styles.detail_item_title}>
										Date Created
									</div>
									<div className={styles.detail_item_content}>
										{clickedUser?.createdAt &&
											dayjs(
												clickedUser?.createdAt
											).format('DD MMM YYYY')}
									</div>
								</Grid>
							</Grid>
							<Grid container xs={12}>
								<Grid
									item
									className={styles.detailItem}
									xs={12}
								>
									<div className={styles.detail_item_title}>
										Projects
									</div>
									<Paper className={styles.projects}>
										{userProjects?.map((userProject) => (
											<div className={styles.project}>
												<Grid container>
													<Grid item xs={6}>
														<div
															className={
																styles.company_name
															}
														>
															{
																userProject.companyName
															}
														</div>
													</Grid>
													<Grid item xs={6}>
														{userProject.roleName && (
															<Chip
																label={
																	userProject.roleName
																}
																className={
																	styles.role_chip
																}
																color='primary'
																style={{
																	backgroundColor: `${userProject.color}`,
																}}
															/>
														)}
													</Grid>
												</Grid>
											</div>
										))}
									</Paper>
								</Grid>
							</Grid>
						</>
					) : (
						<div style={{ height: '30vh' }}></div>
					)}
				</div>
				<div className={styles.projects_content}></div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	userId: state.userManagement.userClicked,
	usersList: state.userManagement.users,
	projects: state.userManagement.projects,
	rolesOfAllProjects: state.userManagement.rolesOfAllProjects,
	projectSelectedCode: state.userManagement.projectSelectedCode,
});

export default connect(mapStateToProps)(UserDetailsCard);
